<template>
  <div class="mt-5 d-flex justify-content-center">
    <nav>
      <ul class="pagination">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <a class="page-link" href="#" @click.prevent="$emit('previous')">Назад</a>
        </li>
        <li class="page-item disabled">
          <span class="page-link">{{ currentPage }} / {{ totalPages }}</span>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <a class="page-link" href="#" @click.prevent="$emit('next')">Вперёд</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
defineProps({
  currentPage: Number,
  totalPages: Number
})
</script>
